// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategorizeGenerateManagementUpdate_main__x7BZ- {
    width: 100%;
    height: 100%;
    padding: 20px;
    border-radius: 6px;
    background-color: #ffffff;
}

.CategorizeGenerateManagementUpdate_item_box__ZmLvI {
    display: flex;
    /* justify-content: center; */
    align-items: center;
    height: 50px;
}

.CategorizeGenerateManagementUpdate_item_title__TyiIn {
    width: 40%;
    text-align: right;
    padding-right: 15px;
}

.CategorizeGenerateManagementUpdate_item_count_message__nnnU- {
    width: 300px;
    height: 32px;
    padding-left: 20px;
    line-height: 32px;
    color: #f00;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/CategorizeGenerateManagementUpdate/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;AACf","sourcesContent":[".main {\n    width: 100%;\n    height: 100%;\n    padding: 20px;\n    border-radius: 6px;\n    background-color: #ffffff;\n}\n\n.item_box {\n    display: flex;\n    /* justify-content: center; */\n    align-items: center;\n    height: 50px;\n}\n\n.item_title {\n    width: 40%;\n    text-align: right;\n    padding-right: 15px;\n}\n\n.item_count_message {\n    width: 300px;\n    height: 32px;\n    padding-left: 20px;\n    line-height: 32px;\n    color: #f00;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `CategorizeGenerateManagementUpdate_main__x7BZ-`,
	"item_box": `CategorizeGenerateManagementUpdate_item_box__ZmLvI`,
	"item_title": `CategorizeGenerateManagementUpdate_item_title__TyiIn`,
	"item_count_message": `CategorizeGenerateManagementUpdate_item_count_message__nnnU-`
};
export default ___CSS_LOADER_EXPORT___;
